module.exports = __webpack_public_path__ + "static/media/Contact-banner@2x.6fe6f8c5.jpg";